import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

// Public route (outside ProtectedRoute) — landing page for the Chatwoot "Reports > Campanhas"
// SSO handoff. Redeems the short-lived, single-use token against GET /api/auth/sso/:token,
// then logs in exactly the same way Login.jsx does (writes token/user to localStorage via
// useAuth().login), and navigates into /crm-view — the top-nav layout built specifically for
// this iframe embed (see TopNavLayout.jsx), instead of the regular sidebar app. Meant to be
// loaded inside an iframe embedded in Chatwoot, so it stays minimal — no branding chrome, just
// a spinner or an error.
const SsoLogin = () => {
  const { token } = useParams();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    const redeem = async () => {
      try {
        const response = await fetch(`/api/auth/sso/${token}`);
        const data = await response.json();

        if (!response.ok || !data?.data?.token) {
          throw new Error(data?.message || 'Falha ao autenticar');
        }

        if (cancelled) return;
        login(data.data.token, data.data.user);
        navigate('/crm-view', { replace: true });
      } catch (err) {
        if (!cancelled) {
          setError(err.message || 'Falha ao autenticar. O link pode ter expirado.');
        }
      }
    };

    redeem();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface">
        <div className="max-w-sm text-center space-y-3 p-6">
          <p className="text-sm font-medium text-on-error-container">{error}</p>
          <Link to="/login" className="text-sm font-medium text-primary hover:text-primary-focus">
            Ir para o login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
    </div>
  );
};

export default SsoLogin;
